/**
 * 招待の受け取り（ログイン不要。招待 URL を持っていることがメールの所有の証明）。
 * 受け取ったあとのログインは、そのメールアドレスへの確認コード。
 */
import { useEffect, useState } from "react";
import { api, type Me } from "../api";
import { Link } from "../router";
import { OnboardingLayout } from "./Onboarding";

export function Invite({ token, signedInAs, onSignedIn }: { token: string; signedInAs: Me | null; onSignedIn: (me: Me) => void }) {
  const [invite, setInvite] = useState<{ email: string; merchantName: string } | null | undefined>(undefined);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    void api.invite(token).then((r) => {
      if (!alive) return;
      if (r.ok) setInvite(r.data);
      else {
        setInvite(null);
        setError(r.error);
      }
    });
    return () => {
      alive = false;
    };
  }, [token]);

  const accept = async () => {
    setBusy(true);
    const r = await api.acceptInvite(token);
    setBusy(false);
    if (!r.ok) return setError(r.error);
    onSignedIn(r.data);
  };

  return (
    <OnboardingLayout title="管理画面へのご招待">
      {invite === undefined && <p className="b2b-lead">招待を確認しています…</p>}
      {invite === null && (
        <div className="b2b-form b2b-stack">
          <p className="b2b-error" role="alert">{error}</p>
          <p className="b2b-note">
            すでに受け取り済みの場合は <Link href="/login">ログイン</Link> してください。
          </p>
        </div>
      )}
      {invite && (
        <div className="b2b-form b2b-stack">
          <p>
            <strong>{invite.merchantName}</strong> の管理画面に、<strong>{invite.email}</strong> でご招待しています。
          </p>
          <p className="b2b-note">
            受け取ると、そのままログインします。次回からは、このメールアドレスに届く確認コードでログインします（パスワードはありません）。
          </p>
          {signedInAs && signedInAs.email !== invite.email && (
            <p className="b2b-notice">いまは {signedInAs.email} でログインしています。受け取ると {invite.email} に切り替わります。</p>
          )}
          {error && <p className="b2b-error" role="alert">{error}</p>}
          <button className="b2b-button" disabled={busy} onClick={() => void accept()}>
            {busy ? "受け取っています…" : "招待を受け取って始める"}
          </button>
        </div>
      )}
    </OnboardingLayout>
  );
}
